var siteExitModal = new bootstrap.Modal('#site-exit-modal');

$(document).on('click', 'a[href^="//"], a[href^="http"]', function(e) {
	// Skip internal links
	if (this.href.includes(window.location.hostname)) return;

	//Hide the exit dialog
	if ($(this).prop('id') === 'site-exit-modal-continue') {
		if($(this).prop('target') === '_blank') $('#site-exit-modal').modal('hide');
		return;
	}
	
	var link = $(this).attr('href');
	var target = $(this).attr('target');
		
	if (link == 'javascript:void(0)' || link.toString().startsWith("#")){
		return false;
	}

	checkExitModalRequired(link,target);
	e.preventDefault();
})

function showExitModal(exclusionCheckResult){
	$('#site-exit-modal-continue').prop('href',exclusionCheckResult.url)
	$('#site-exit-modal-continue').prop('target',exclusionCheckResult.target)
	if(exclusionCheckResult.target === '_blank') $('#site-exit-modal-target-notice').removeClass();
	else $('#site-exit-modal-target-notice').prop('class','d-none');
	siteExitModal.show();
	document.querySelector('#site-exit-modal-continue').addEventListener('click',function () { siteExitModal.hide() });
}

async function isTrustedDomain(url) {
	const domain = getDomainFromUrl(url);
	if (!domain) return false;
	const domainHash = await hashDomain(domain);
	const result = lotdh.includes(domainHash);
	return result;
}

function normalizeDomain(domain) {
	return domain.replace(/^www\./, '').toLowerCase();
}

function getDomainFromUrl(url) {
	try {
		return new URL(url, window.location.href).hostname;
	} catch (e) {
		return null;
	}
}

async function hashDomain(domain) {
	const normalized = normalizeDomain(domain);
	const hash = await hasher(normalized);
	return hash;
}

async function hasher(text) {
	const encoder = new TextEncoder();
	const data = encoder.encode(text);
	const hashBuffer = await crypto.subtle.digest('SHA-256', data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

async function checkExitModalRequired(link,target){
	const trusted = await isTrustedDomain(link);
	if(trusted){
		if(target === '_blank'){
			setTimeout(() => {
				window.open(link, '_blank');
			});
		}else{
			window.location.href = link;
		}
	}else{
		showExitModal({url: link, target: target});
	}
}